import { Flex, Text } from '@shared/components';

interface SummaryStatsGroupProps {
  totalQConfigs: number | null;
  successfulQConfigs: number | null;
  failedQConfigs: number | null;
}

export default function SummaryStatsGroup(props: Readonly<SummaryStatsGroupProps>) {
  const { totalQConfigs, successfulQConfigs, failedQConfigs } = props;
  return (
    <Flex sx={(theme) => ({ gap: theme.spacing(4), width: '100%' })}>
      <Flex
        sx={(theme) => ({
          borderRadius: theme.shape.rounded(2),
          backgroundColor: theme.palette.grey[100],
          p: theme.spacing(4),
          flexDirection: 'column',
          width: '100%',
        })}
      >
        <Text>จำนวน QConfig ทั้งหมด</Text>
        <Text variant='h3'>{totalQConfigs ?? '-'} แบบ</Text>
      </Flex>
      <Flex
        sx={(theme) => ({
          borderRadius: theme.shape.rounded(2),
          backgroundColor: theme.palette.success.lighter,
          p: theme.spacing(4),
          width: '100%',
          flexDirection: 'column',
        })}
      >
        <Text sx={(theme) => ({ color: theme.palette.success.dark })}>ผ่านเกณฑ์</Text>
        <Text variant='h3' sx={(theme) => ({ color: theme.palette.success.dark })}>
          {successfulQConfigs ?? '-'} แบบ
        </Text>
      </Flex>
      <Flex
        sx={(theme) => ({
          borderRadius: theme.shape.rounded(2),
          backgroundColor: theme.palette.error.lighter,
          p: theme.spacing(4),
          flexDirection: 'column',
          width: '100%',
        })}
      >
        <Text sx={(theme) => ({ color: theme.palette.error.main })}>ไม่ผ่านเกณฑ์</Text>
        <Text variant='h3' sx={(theme) => ({ color: theme.palette.error.main })}>
          {failedQConfigs ?? '-'} แบบ
        </Text>
      </Flex>
    </Flex>
  );
}
